export type ThemeType = typeof theme

export enum ThemeModes {
    LIGHT = 'light',
    HIGH_CONTRAST = 'highContrast',
}

export function transparent(hslColorString: string, opacity: number) {
    const matchedArr =
        hslColorString.match(/hsl\(\s*(\d+)\s*,\s*(\d+)%\s*,\s*(\d+)%\s*\)/) ||
        []
    const [hue, saturation, lightness] = matchedArr.slice(1).map(Number)

    const opacityInAllowedRange = Math.min(Math.max(opacity, 0), 1)

    return `hsla(${hue}, ${saturation}%, ${lightness}%, ${opacityInAllowedRange})`
}

export const theme = {
    black: 'hsl(0, 0%, 0%)',
    gray: 'hsl(0, 0%, 90%)',
    white: 'hsla(0, 0%, 100%, 1)',
    primary: 'hsl(211, 92%, 44%)',
    neutral: 'hsla(0, 0%, 35%, 1)',
    dust_red: 'hsla(355, 83%, 44%, 1)',
    calendula_gold: 'hsla(40, 96%, 53%, 1)',
    polar_green: 'hsla(100, 77%, 44%, 1)',
    colorBgBase: 'white',

    red: {
        100: 'hsl(360, 71%, 80%)',
        900: 'hsl(0, 92%, 15%)',
    },

    geekblue: {
        100: 'hsl(220, 100%, 97%)',
        200: 'hsl(220, 100%, 92%)',
        300: 'hsl(227, 71%, 80%)',
        900: 'hsl(216, 92%, 15%)',
    },

    blue: {
        100: 'hsl(209, 71%, 80%)',
        900: 'hsl(212, 92%, 15%)',
    },

    purple: {
        100: 'hsl(248, 71%, 80%)',
        900: 'hsl(256, 92%, 15%)',
    },

    green: {
        100: 'hsl(151, 71%, 80%)',
        900: 'hsl(144, 92%, 15%)',
    },

    magenta: {
        100: 'hsl(331, 71%, 80%)',
        900: 'hsl(328, 92%, 15%)',
    },

    volcano: {
        100: 'hsl(360, 93%, 78%)',
        900: 'hsl(360, 95%, 11%)',
    },

    highContrast: {
        primary: 'hsl(54, 100%, 52%)',
        secondary: 'hsla(0, 0%, 99%, 0.12)',
        colorBtnText: 'hsl(0, 0%, 7%)',
        colorBgBase: 'hsl(0, 0%, 7%)',
        colorBgSecondary: 'hsl(0, 0%, 8%)',
        colorBgElevated: 'hsl(0, 0%, 11%)',
        colorError: 'hsl(4, 100%, 71%)',
    },

    borderRadius: 3,

    fontWeight: {
        light: 300,
        regular: 400,
        medium: 500,
        bold: 600,
    },

    fontSize: {
        xxl: '4rem',
        xl: '2.4rem',
        l: '1.6rem',
        m: '1.4rem',
        s: '1.2rem',
        xs: '1rem',
    },

    shadow: {
        primary:
            '0px 3px 6px -4px hsla(0, 0%, 0%, 0.12), 0px 6px 16px hsla(0, 0%, 0%, 0.08), 0px 9px 28px 8px hsla(0, 0%, 0%, 0.05)',
    },
}
